import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _54e9e886 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _264b386a = () => interopDefault(import('../pages/business/index.vue' /* webpackChunkName: "pages/business/index" */))
const _57a45406 = () => interopDefault(import('../pages/categories/index.vue' /* webpackChunkName: "pages/categories/index" */))
const _883c91f4 = () => interopDefault(import('../pages/healthy.vue' /* webpackChunkName: "pages/healthy" */))
const _29349af3 = () => interopDefault(import('../pages/message/index.vue' /* webpackChunkName: "pages/message/index" */))
const _1932a636 = () => interopDefault(import('../pages/mypage/index.vue' /* webpackChunkName: "pages/mypage/index" */))
const _0bfeb924 = () => interopDefault(import('../pages/requests/index.vue' /* webpackChunkName: "pages/requests/index" */))
const _7249b412 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _25dddb88 = () => interopDefault(import('../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _06b48749 = () => interopDefault(import('../pages/switch_account.vue' /* webpackChunkName: "pages/switch_account" */))
const _9d2f6818 = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _3bf34f04 = () => interopDefault(import('../pages/blogs/categories/index.vue' /* webpackChunkName: "pages/blogs/categories/index" */))
const _624c43e0 = () => interopDefault(import('../pages/blogs/search/index.vue' /* webpackChunkName: "pages/blogs/search/index" */))
const _0dc55dbf = () => interopDefault(import('../pages/business/continue.vue' /* webpackChunkName: "pages/business/continue" */))
const _db61de96 = () => interopDefault(import('../pages/business/introduction/index.vue' /* webpackChunkName: "pages/business/introduction/index" */))
const _91884dd6 = () => interopDefault(import('../pages/business/projects/index.vue' /* webpackChunkName: "pages/business/projects/index" */))
const _2c47e004 = () => interopDefault(import('../pages/business/register/index.vue' /* webpackChunkName: "pages/business/register/index" */))
const _39cfbd7e = () => interopDefault(import('../pages/business/settings/index.vue' /* webpackChunkName: "pages/business/settings/index" */))
const _543fd830 = () => interopDefault(import('../pages/business/top/index.vue' /* webpackChunkName: "pages/business/top/index" */))
const _7c861d1a = () => interopDefault(import('../pages/enterprise/invitations.vue' /* webpackChunkName: "pages/enterprise/invitations" */))
const _5ce705ca = () => interopDefault(import('../pages/enterprise/lp.vue' /* webpackChunkName: "pages/enterprise/lp" */))
const _04ffaf92 = () => interopDefault(import('../pages/enterprise/members.vue' /* webpackChunkName: "pages/enterprise/members" */))
const _75daa27c = () => interopDefault(import('../pages/enterprise/orders.vue' /* webpackChunkName: "pages/enterprise/orders" */))
const _16c667da = () => interopDefault(import('../pages/error/404.vue' /* webpackChunkName: "pages/error/404" */))
const _53663fdc = () => interopDefault(import('../pages/mypage/analytics/index.vue' /* webpackChunkName: "pages/mypage/analytics/index" */))
const _c52ef690 = () => interopDefault(import('../pages/mypage/blog_orders/index.vue' /* webpackChunkName: "pages/mypage/blog_orders/index" */))
const _db7265b2 = () => interopDefault(import('../pages/mypage/blogs/index.vue' /* webpackChunkName: "pages/mypage/blogs/index" */))
const _4e9ea548 = () => interopDefault(import('../pages/mypage/code_apply/index.vue' /* webpackChunkName: "pages/mypage/code_apply/index" */))
const _24cc0827 = () => interopDefault(import('../pages/mypage/dashboard.vue' /* webpackChunkName: "pages/mypage/dashboard" */))
const _cfd7858e = () => interopDefault(import('../pages/mypage/dashboard_provider.vue' /* webpackChunkName: "pages/mypage/dashboard_provider" */))
const _e28337ee = () => interopDefault(import('../pages/mypage/invite/index.vue' /* webpackChunkName: "pages/mypage/invite/index" */))
const _7da7dfe2 = () => interopDefault(import('../pages/mypage/orders.vue' /* webpackChunkName: "pages/mypage/orders" */))
const _37039a56 = () => interopDefault(import('../pages/mypage/orders/canceled.vue' /* webpackChunkName: "pages/mypage/orders/canceled" */))
const _76e80a2e = () => interopDefault(import('../pages/mypage/orders/closed.vue' /* webpackChunkName: "pages/mypage/orders/closed" */))
const _de1b4fcc = () => interopDefault(import('../pages/mypage/orders/flags.vue' /* webpackChunkName: "pages/mypage/orders/flags" */))
const _9056d3f2 = () => interopDefault(import('../pages/mypage/orders/open.vue' /* webpackChunkName: "pages/mypage/orders/open" */))
const _573a2ffe = () => interopDefault(import('../pages/mypage/orders/requests.vue' /* webpackChunkName: "pages/mypage/orders/requests" */))
const _24954e5c = () => interopDefault(import('../pages/mypage/orders/required.vue' /* webpackChunkName: "pages/mypage/orders/required" */))
const _2fd69c4b = () => interopDefault(import('../pages/mypage/orders/trash.vue' /* webpackChunkName: "pages/mypage/orders/trash" */))
const _a260be8e = () => interopDefault(import('../pages/mypage/promotion/index.vue' /* webpackChunkName: "pages/mypage/promotion/index" */))
const _cd9efa0e = () => interopDefault(import('../pages/mypage/received_favorites/index.vue' /* webpackChunkName: "pages/mypage/received_favorites/index" */))
const _3fa343ea = () => interopDefault(import('../pages/mypage/received_favorites_blogs/index.vue' /* webpackChunkName: "pages/mypage/received_favorites_blogs/index" */))
const _87e8c37c = () => interopDefault(import('../pages/mypage/received_favorites_users/index.vue' /* webpackChunkName: "pages/mypage/received_favorites_users/index" */))
const _40ffa654 = () => interopDefault(import('../pages/mypage/received_orders.vue' /* webpackChunkName: "pages/mypage/received_orders" */))
const _0bc09fe2 = () => interopDefault(import('../pages/mypage/received_orders/canceled.vue' /* webpackChunkName: "pages/mypage/received_orders/canceled" */))
const _08b61916 = () => interopDefault(import('../pages/mypage/received_orders/closed.vue' /* webpackChunkName: "pages/mypage/received_orders/closed" */))
const _145bc3e4 = () => interopDefault(import('../pages/mypage/received_orders/flags.vue' /* webpackChunkName: "pages/mypage/received_orders/flags" */))
const _0daa4193 = () => interopDefault(import('../pages/mypage/received_orders/open.vue' /* webpackChunkName: "pages/mypage/received_orders/open" */))
const _adc024e6 = () => interopDefault(import('../pages/mypage/received_orders/requests.vue' /* webpackChunkName: "pages/mypage/received_orders/requests" */))
const _0d5b5830 = () => interopDefault(import('../pages/mypage/received_orders/required.vue' /* webpackChunkName: "pages/mypage/received_orders/required" */))
const _d6933b82 = () => interopDefault(import('../pages/mypage/received_orders/trash.vue' /* webpackChunkName: "pages/mypage/received_orders/trash" */))
const _2798efea = () => interopDefault(import('../pages/mypage/received_orders/user/_userId.vue' /* webpackChunkName: "pages/mypage/received_orders/user/_userId" */))
const _460e5e2f = () => interopDefault(import('../pages/mypage/sms/index.vue' /* webpackChunkName: "pages/mypage/sms/index" */))
const _3bbec8ea = () => interopDefault(import('../pages/mypage/user/index.vue' /* webpackChunkName: "pages/mypage/user/index" */))
const _67cfd7eb = () => interopDefault(import('../pages/pages/about.vue' /* webpackChunkName: "pages/pages/about" */))
const _413f79c9 = () => interopDefault(import('../pages/pages/terms_promotion.vue' /* webpackChunkName: "pages/pages/terms_promotion" */))
const _84faacae = () => interopDefault(import('../pages/points/record/index.vue' /* webpackChunkName: "pages/points/record/index" */))
const _4a8f73d3 = () => interopDefault(import('../pages/points/top/index.vue' /* webpackChunkName: "pages/points/top/index" */))
const _5fe0e4bd = () => interopDefault(import('../pages/requests/add.vue' /* webpackChunkName: "pages/requests/add" */))
const _26157c0e = () => interopDefault(import('../pages/users/search/index.vue' /* webpackChunkName: "pages/users/search/index" */))
const _43d7361e = () => interopDefault(import('../pages/blogs/orders/redirect.vue' /* webpackChunkName: "pages/blogs/orders/redirect" */))
const _3b0519f7 = () => interopDefault(import('../pages/business/questionnaire/completed.vue' /* webpackChunkName: "pages/business/questionnaire/completed" */))
const _2dd56f98 = () => interopDefault(import('../pages/business/questionnaire/corporation.vue' /* webpackChunkName: "pages/business/questionnaire/corporation" */))
const _25e93b2f = () => interopDefault(import('../pages/business/questionnaire/genre.vue' /* webpackChunkName: "pages/business/questionnaire/genre" */))
const _c5193462 = () => interopDefault(import('../pages/business/questionnaire/user.vue' /* webpackChunkName: "pages/business/questionnaire/user" */))
const _0bc22eda = () => interopDefault(import('../pages/business/register/account_difference.vue' /* webpackChunkName: "pages/business/register/account_difference" */))
const _277650bf = () => interopDefault(import('../pages/business/register/account_expired.vue' /* webpackChunkName: "pages/business/register/account_expired" */))
const _fbb8e212 = () => interopDefault(import('../pages/business/register/completed.vue' /* webpackChunkName: "pages/business/register/completed" */))
const _413b78ae = () => interopDefault(import('../pages/business/register/email_expired.vue' /* webpackChunkName: "pages/business/register/email_expired" */))
const _3e31220f = () => interopDefault(import('../pages/business/register/email_verified.vue' /* webpackChunkName: "pages/business/register/email_verified" */))
const _419a19b0 = () => interopDefault(import('../pages/business/register/enter_business_email.vue' /* webpackChunkName: "pages/business/register/enter_business_email" */))
const _5a54e41e = () => interopDefault(import('../pages/business/register/enter_information.vue' /* webpackChunkName: "pages/business/register/enter_information" */))
const _54b342d2 = () => interopDefault(import('../pages/business/register/enter_open_id_email.vue' /* webpackChunkName: "pages/business/register/enter_open_id_email" */))
const _b52ca536 = () => interopDefault(import('../pages/business/register/enter_private_email.vue' /* webpackChunkName: "pages/business/register/enter_private_email" */))
const _e60db6c6 = () => interopDefault(import('../pages/business/register/invitation.vue' /* webpackChunkName: "pages/business/register/invitation" */))
const _25185566 = () => interopDefault(import('../pages/business/register/invitation_error.vue' /* webpackChunkName: "pages/business/register/invitation_error" */))
const _549d2974 = () => interopDefault(import('../pages/business/register/migration_completed.vue' /* webpackChunkName: "pages/business/register/migration_completed" */))
const _73bd4bb7 = () => interopDefault(import('../pages/business/register/migration_description.vue' /* webpackChunkName: "pages/business/register/migration_description" */))
const _5d632831 = () => interopDefault(import('../pages/business/register/select_account_existence.vue' /* webpackChunkName: "pages/business/register/select_account_existence" */))
const _13953c3f = () => interopDefault(import('../pages/business/register/select_account_pattern.vue' /* webpackChunkName: "pages/business/register/select_account_pattern" */))
const _612b589d = () => interopDefault(import('../pages/business/register/select_email.vue' /* webpackChunkName: "pages/business/register/select_email" */))
const _23ca4cc2 = () => interopDefault(import('../pages/business/register/select_id_type.vue' /* webpackChunkName: "pages/business/register/select_id_type" */))
const _409c3a5c = () => interopDefault(import('../pages/business/register/sending_completed.vue' /* webpackChunkName: "pages/business/register/sending_completed" */))
const _13a59428 = () => interopDefault(import('../pages/business/register/welcome_back.vue' /* webpackChunkName: "pages/business/register/welcome_back" */))
const _27578459 = () => interopDefault(import('../pages/business/settings/account.vue' /* webpackChunkName: "pages/business/settings/account" */))
const _39460ab4 = () => interopDefault(import('../pages/business/settings/corporation.vue' /* webpackChunkName: "pages/business/settings/corporation" */))
const _017e95c6 = () => interopDefault(import('../pages/business/settings/delete_account.vue' /* webpackChunkName: "pages/business/settings/delete_account" */))
const _7f54854e = () => interopDefault(import('../pages/business/settings/invoice.vue' /* webpackChunkName: "pages/business/settings/invoice" */))
const _1480734f = () => interopDefault(import('../pages/business/settings/user.vue' /* webpackChunkName: "pages/business/settings/user" */))
const _28821687 = () => interopDefault(import('../pages/callBack/blog/mobileCarriers.vue' /* webpackChunkName: "pages/callBack/blog/mobileCarriers" */))
const _830e47ba = () => interopDefault(import('../pages/mypage/activities/notification/index.vue' /* webpackChunkName: "pages/mypage/activities/notification/index" */))
const _cae39208 = () => interopDefault(import('../pages/mypage/activities/transaction/index.vue' /* webpackChunkName: "pages/mypage/activities/transaction/index" */))
const _1ce828b6 = () => interopDefault(import('../pages/mypage/blogs/add.vue' /* webpackChunkName: "pages/mypage/blogs/add" */))
const _d671d0a2 = () => interopDefault(import('../pages/mypage/favorites/blogs/index.vue' /* webpackChunkName: "pages/mypage/favorites/blogs/index" */))
const _2c5a0c02 = () => interopDefault(import('../pages/mypage/promotion/payment_history.vue' /* webpackChunkName: "pages/mypage/promotion/payment_history" */))
const _c9813cbe = () => interopDefault(import('../pages/mypage/promotion/refund.vue' /* webpackChunkName: "pages/mypage/promotion/refund" */))
const _270277da = () => interopDefault(import('../pages/mypage/promotion/start_setting.vue' /* webpackChunkName: "pages/mypage/promotion/start_setting" */))
const _cc9024a4 = () => interopDefault(import('../pages/mypage/user/careers.vue' /* webpackChunkName: "pages/mypage/user/careers" */))
const _25065cc2 = () => interopDefault(import('../pages/mypage/user/portfolios.vue' /* webpackChunkName: "pages/mypage/user/portfolios" */))
const _9fd26c76 = () => interopDefault(import('../pages/mypage/user/portfolios/index.vue' /* webpackChunkName: "pages/mypage/user/portfolios/index" */))
const _3d3857a1 = () => interopDefault(import('../pages/mypage/user/portfolios/_portfolioId.vue' /* webpackChunkName: "pages/mypage/user/portfolios/_portfolioId" */))
const _3c40be3e = () => interopDefault(import('../pages/mypage/user/prices.vue' /* webpackChunkName: "pages/mypage/user/prices" */))
const _1d62d614 = () => interopDefault(import('../pages/mypage/user/reviews.vue' /* webpackChunkName: "pages/mypage/user/reviews" */))
const _93656996 = () => interopDefault(import('../pages/mypage/user/services.vue' /* webpackChunkName: "pages/mypage/user/services" */))
const _549adc3c = () => interopDefault(import('../pages/customize/requests/add/_userId/index.vue' /* webpackChunkName: "pages/customize/requests/add/_userId/index" */))
const _4c9db870 = () => interopDefault(import('../pages/mypage/blogs/edit/_id.vue' /* webpackChunkName: "pages/mypage/blogs/edit/_id" */))
const _a6468990 = () => interopDefault(import('../pages/mypage/customize/requests/_id/detail.vue' /* webpackChunkName: "pages/mypage/customize/requests/_id/detail" */))
const _3f610458 = () => interopDefault(import('../pages/mypage/ordermade/requests/_id/detail.vue' /* webpackChunkName: "pages/mypage/ordermade/requests/_id/detail" */))
const _5c041ed1 = () => interopDefault(import('../pages/customize/requests/add/_userId/_serviceId.vue' /* webpackChunkName: "pages/customize/requests/add/_userId/_serviceId" */))
const _f76c5198 = () => interopDefault(import('../pages/mypage/promotion/receipt/_year/_month.vue' /* webpackChunkName: "pages/mypage/promotion/receipt/_year/_month" */))
const _741b1fcc = () => interopDefault(import('../pages/blogs/categories/_blogCategoryId.vue' /* webpackChunkName: "pages/blogs/categories/_blogCategoryId" */))
const _ea77f044 = () => interopDefault(import('../pages/blogs/ss/_hashId.vue' /* webpackChunkName: "pages/blogs/ss/_hashId" */))
const _14a71cbd = () => interopDefault(import('../pages/business/projects/_id.vue' /* webpackChunkName: "pages/business/projects/_id" */))
const _5b43356b = () => interopDefault(import('../pages/campaign/participations/_campaignEventId.vue' /* webpackChunkName: "pages/campaign/participations/_campaignEventId" */))
const _0455bf8d = () => interopDefault(import('../pages/forms/delivery/_talkroomId.vue' /* webpackChunkName: "pages/forms/delivery/_talkroomId" */))
const _6bdb98e8 = () => interopDefault(import('../pages/forms/estimate/_offerId.vue' /* webpackChunkName: "pages/forms/estimate/_offerId" */))
const _656f092e = () => interopDefault(import('../pages/forms/order/_talkroomId.vue' /* webpackChunkName: "pages/forms/order/_talkroomId" */))
const _37fa8944 = () => interopDefault(import('../pages/mypage/analytics/_id.vue' /* webpackChunkName: "pages/mypage/analytics/_id" */))
const _325219d2 = () => interopDefault(import('../pages/mypage/blog_orders/_blogOrderId.vue' /* webpackChunkName: "pages/mypage/blog_orders/_blogOrderId" */))
const _2c6fe70e = () => interopDefault(import('../pages/requests/categories/_categoryId.vue' /* webpackChunkName: "pages/requests/categories/_categoryId" */))
const _26ba7f64 = () => interopDefault(import('../pages/customize/requests/_id/detail.vue' /* webpackChunkName: "pages/customize/requests/_id/detail" */))
const _214c2809 = () => interopDefault(import('../pages/mypage/blog_charges/_blogChargeId/receipt.vue' /* webpackChunkName: "pages/mypage/blog_charges/_blogChargeId/receipt" */))
const _7f27096e = () => interopDefault(import('../pages/ordermade/requests/_id/detail.vue' /* webpackChunkName: "pages/ordermade/requests/_id/detail" */))
const _344e0028 = () => interopDefault(import('../pages/blogs/_id/index.vue' /* webpackChunkName: "pages/blogs/_id/index" */))
const _0940d50f = () => interopDefault(import('../pages/categories/_categoryId/index.vue' /* webpackChunkName: "pages/categories/_categoryId/index" */))
const _02c6ad54 = () => interopDefault(import('../pages/requests/_id.vue' /* webpackChunkName: "pages/requests/_id" */))
const _30bd1ff0 = () => interopDefault(import('../pages/services/_id.vue' /* webpackChunkName: "pages/services/_id" */))
const _232d4ff2 = () => interopDefault(import('../pages/talkrooms/_talkroomId.vue' /* webpackChunkName: "pages/talkrooms/_talkroomId" */))
const _661f7d4a = () => interopDefault(import('../pages/talkrooms/_talkroomId/index.vue' /* webpackChunkName: "pages/talkrooms/_talkroomId/index" */))
const _ce9d36b8 = () => interopDefault(import('../pages/talkrooms/_talkroomId/information.vue' /* webpackChunkName: "pages/talkrooms/_talkroomId/information" */))
const _62924cdf = () => interopDefault(import('../pages/users/_id/index.vue' /* webpackChunkName: "pages/users/_id/index" */))
const _76facbfc = () => interopDefault(import('../pages/users/_id/careers.vue' /* webpackChunkName: "pages/users/_id/careers" */))
const _475b4024 = () => interopDefault(import('../pages/users/_id/portfolios.vue' /* webpackChunkName: "pages/users/_id/portfolios" */))
const _eeb2881e = () => interopDefault(import('../pages/users/_id/portfolios/index.vue' /* webpackChunkName: "pages/users/_id/portfolios/index" */))
const _2ce7dbf5 = () => interopDefault(import('../pages/users/_id/portfolios/_portfolioId.vue' /* webpackChunkName: "pages/users/_id/portfolios/_portfolioId" */))
const _6fa41a0d = () => interopDefault(import('../pages/users/_id/prices.vue' /* webpackChunkName: "pages/users/_id/prices" */))
const _482d8268 = () => interopDefault(import('../pages/users/_id/reviews.vue' /* webpackChunkName: "pages/users/_id/reviews" */))
const _364fad3e = () => interopDefault(import('../pages/users/_id/services.vue' /* webpackChunkName: "pages/users/_id/services" */))
const _6f08d052 = () => interopDefault(import('../pages/blogs/_id/_blogId.vue' /* webpackChunkName: "pages/blogs/_id/_blogId" */))
const _7bf0f6f4 = () => interopDefault(import('../pages/blogs/_id/_blogId/complete.vue' /* webpackChunkName: "pages/blogs/_id/_blogId/complete" */))
const _55515983 = () => interopDefault(import('../pages/blogs/_id/_blogId/confirm.vue' /* webpackChunkName: "pages/blogs/_id/_blogId/confirm" */))
const _96cf7766 = () => interopDefault(import('../pages/blogs/_id/_blogId/input.vue' /* webpackChunkName: "pages/blogs/_id/_blogId/input" */))
const _0d600bf2 = () => interopDefault(import('../pages/categories/_categoryId/_categoryTypeId/index.vue' /* webpackChunkName: "pages/categories/_categoryId/_categoryTypeId/index" */))
const _140b13fb = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blogs",
    component: _54e9e886,
    name: "blogs"
  }, {
    path: "/business",
    component: _264b386a,
    name: "business"
  }, {
    path: "/categories",
    component: _57a45406,
    name: "categories"
  }, {
    path: "/healthy",
    component: _883c91f4,
    name: "healthy"
  }, {
    path: "/message",
    component: _29349af3,
    name: "message"
  }, {
    path: "/mypage",
    component: _1932a636,
    name: "mypage"
  }, {
    path: "/requests",
    component: _0bfeb924,
    name: "requests"
  }, {
    path: "/search",
    component: _7249b412,
    name: "search"
  }, {
    path: "/services",
    component: _25dddb88,
    name: "services"
  }, {
    path: "/switch_account",
    component: _06b48749,
    name: "switch_account"
  }, {
    path: "/users",
    component: _9d2f6818,
    name: "users"
  }, {
    path: "/blogs/categories",
    component: _3bf34f04,
    name: "blogs-categories"
  }, {
    path: "/blogs/search",
    component: _624c43e0,
    name: "blogs-search"
  }, {
    path: "/business/continue",
    component: _0dc55dbf,
    name: "business-continue"
  }, {
    path: "/business/introduction",
    component: _db61de96,
    name: "business-introduction"
  }, {
    path: "/business/projects",
    component: _91884dd6,
    name: "business-projects"
  }, {
    path: "/business/register",
    component: _2c47e004,
    name: "business-register"
  }, {
    path: "/business/settings",
    component: _39cfbd7e,
    name: "business-settings"
  }, {
    path: "/business/top",
    component: _543fd830,
    name: "business-top"
  }, {
    path: "/enterprise/invitations",
    component: _7c861d1a,
    name: "enterprise-invitations"
  }, {
    path: "/enterprise/lp",
    component: _5ce705ca,
    name: "enterprise-lp"
  }, {
    path: "/enterprise/members",
    component: _04ffaf92,
    name: "enterprise-members"
  }, {
    path: "/enterprise/orders",
    component: _75daa27c,
    name: "enterprise-orders"
  }, {
    path: "/error/404",
    component: _16c667da,
    name: "error-404"
  }, {
    path: "/mypage/analytics",
    component: _53663fdc,
    name: "mypage-analytics"
  }, {
    path: "/mypage/blog_orders",
    component: _c52ef690,
    name: "mypage-blog_orders"
  }, {
    path: "/mypage/blogs",
    component: _db7265b2,
    name: "mypage-blogs"
  }, {
    path: "/mypage/code_apply",
    component: _4e9ea548,
    name: "mypage-code_apply"
  }, {
    path: "/mypage/dashboard",
    component: _24cc0827,
    name: "mypage-dashboard"
  }, {
    path: "/mypage/dashboard_provider",
    component: _cfd7858e,
    name: "mypage-dashboard_provider"
  }, {
    path: "/mypage/invite",
    component: _e28337ee,
    name: "mypage-invite"
  }, {
    path: "/mypage/orders",
    component: _7da7dfe2,
    name: "mypage-orders",
    children: [{
      path: "canceled",
      component: _37039a56,
      name: "mypage-orders-canceled"
    }, {
      path: "closed",
      component: _76e80a2e,
      name: "mypage-orders-closed"
    }, {
      path: "flags",
      component: _de1b4fcc,
      name: "mypage-orders-flags"
    }, {
      path: "open",
      component: _9056d3f2,
      name: "mypage-orders-open"
    }, {
      path: "requests",
      component: _573a2ffe,
      name: "mypage-orders-requests"
    }, {
      path: "required",
      component: _24954e5c,
      name: "mypage-orders-required"
    }, {
      path: "trash",
      component: _2fd69c4b,
      name: "mypage-orders-trash"
    }]
  }, {
    path: "/mypage/promotion",
    component: _a260be8e,
    name: "mypage-promotion"
  }, {
    path: "/mypage/received_favorites",
    component: _cd9efa0e,
    name: "mypage-received_favorites"
  }, {
    path: "/mypage/received_favorites_blogs",
    component: _3fa343ea,
    name: "mypage-received_favorites_blogs"
  }, {
    path: "/mypage/received_favorites_users",
    component: _87e8c37c,
    name: "mypage-received_favorites_users"
  }, {
    path: "/mypage/received_orders",
    component: _40ffa654,
    name: "mypage-received_orders",
    children: [{
      path: "canceled",
      component: _0bc09fe2,
      name: "mypage-received_orders-canceled"
    }, {
      path: "closed",
      component: _08b61916,
      name: "mypage-received_orders-closed"
    }, {
      path: "flags",
      component: _145bc3e4,
      name: "mypage-received_orders-flags"
    }, {
      path: "open",
      component: _0daa4193,
      name: "mypage-received_orders-open"
    }, {
      path: "requests",
      component: _adc024e6,
      name: "mypage-received_orders-requests"
    }, {
      path: "required",
      component: _0d5b5830,
      name: "mypage-received_orders-required"
    }, {
      path: "trash",
      component: _d6933b82,
      name: "mypage-received_orders-trash"
    }, {
      path: "user/:userId?",
      component: _2798efea,
      name: "mypage-received_orders-user-userId"
    }]
  }, {
    path: "/mypage/sms",
    component: _460e5e2f,
    name: "mypage-sms"
  }, {
    path: "/mypage/user",
    component: _3bbec8ea,
    name: "mypage-user"
  }, {
    path: "/pages/about",
    component: _67cfd7eb,
    name: "pages-about"
  }, {
    path: "/pages/terms_promotion",
    component: _413f79c9,
    name: "pages-terms_promotion"
  }, {
    path: "/points/record",
    component: _84faacae,
    name: "points-record"
  }, {
    path: "/points/top",
    component: _4a8f73d3,
    name: "points-top"
  }, {
    path: "/requests/add",
    component: _5fe0e4bd,
    name: "requests-add"
  }, {
    path: "/users/search",
    component: _26157c0e,
    name: "users-search"
  }, {
    path: "/blogs/orders/redirect",
    component: _43d7361e,
    name: "blogs-orders-redirect"
  }, {
    path: "/business/questionnaire/completed",
    component: _3b0519f7,
    name: "business-questionnaire-completed"
  }, {
    path: "/business/questionnaire/corporation",
    component: _2dd56f98,
    name: "business-questionnaire-corporation"
  }, {
    path: "/business/questionnaire/genre",
    component: _25e93b2f,
    name: "business-questionnaire-genre"
  }, {
    path: "/business/questionnaire/user",
    component: _c5193462,
    name: "business-questionnaire-user"
  }, {
    path: "/business/register/account_difference",
    component: _0bc22eda,
    name: "business-register-account_difference"
  }, {
    path: "/business/register/account_expired",
    component: _277650bf,
    name: "business-register-account_expired"
  }, {
    path: "/business/register/completed",
    component: _fbb8e212,
    name: "business-register-completed"
  }, {
    path: "/business/register/email_expired",
    component: _413b78ae,
    name: "business-register-email_expired"
  }, {
    path: "/business/register/email_verified",
    component: _3e31220f,
    name: "business-register-email_verified"
  }, {
    path: "/business/register/enter_business_email",
    component: _419a19b0,
    name: "business-register-enter_business_email"
  }, {
    path: "/business/register/enter_information",
    component: _5a54e41e,
    name: "business-register-enter_information"
  }, {
    path: "/business/register/enter_open_id_email",
    component: _54b342d2,
    name: "business-register-enter_open_id_email"
  }, {
    path: "/business/register/enter_private_email",
    component: _b52ca536,
    name: "business-register-enter_private_email"
  }, {
    path: "/business/register/invitation",
    component: _e60db6c6,
    name: "business-register-invitation"
  }, {
    path: "/business/register/invitation_error",
    component: _25185566,
    name: "business-register-invitation_error"
  }, {
    path: "/business/register/migration_completed",
    component: _549d2974,
    name: "business-register-migration_completed"
  }, {
    path: "/business/register/migration_description",
    component: _73bd4bb7,
    name: "business-register-migration_description"
  }, {
    path: "/business/register/select_account_existence",
    component: _5d632831,
    name: "business-register-select_account_existence"
  }, {
    path: "/business/register/select_account_pattern",
    component: _13953c3f,
    name: "business-register-select_account_pattern"
  }, {
    path: "/business/register/select_email",
    component: _612b589d,
    name: "business-register-select_email"
  }, {
    path: "/business/register/select_id_type",
    component: _23ca4cc2,
    name: "business-register-select_id_type"
  }, {
    path: "/business/register/sending_completed",
    component: _409c3a5c,
    name: "business-register-sending_completed"
  }, {
    path: "/business/register/welcome_back",
    component: _13a59428,
    name: "business-register-welcome_back"
  }, {
    path: "/business/settings/account",
    component: _27578459,
    name: "business-settings-account"
  }, {
    path: "/business/settings/corporation",
    component: _39460ab4,
    name: "business-settings-corporation"
  }, {
    path: "/business/settings/delete_account",
    component: _017e95c6,
    name: "business-settings-delete_account"
  }, {
    path: "/business/settings/invoice",
    component: _7f54854e,
    name: "business-settings-invoice"
  }, {
    path: "/business/settings/user",
    component: _1480734f,
    name: "business-settings-user"
  }, {
    path: "/callBack/blog/mobileCarriers",
    component: _28821687,
    name: "callBack-blog-mobileCarriers"
  }, {
    path: "/mypage/activities/notification",
    component: _830e47ba,
    name: "mypage-activities-notification"
  }, {
    path: "/mypage/activities/transaction",
    component: _cae39208,
    name: "mypage-activities-transaction"
  }, {
    path: "/mypage/blogs/add",
    component: _1ce828b6,
    name: "mypage-blogs-add"
  }, {
    path: "/mypage/favorites/blogs",
    component: _d671d0a2,
    name: "mypage-favorites-blogs"
  }, {
    path: "/mypage/promotion/payment_history",
    component: _2c5a0c02,
    name: "mypage-promotion-payment_history"
  }, {
    path: "/mypage/promotion/refund",
    component: _c9813cbe,
    name: "mypage-promotion-refund"
  }, {
    path: "/mypage/promotion/start_setting",
    component: _270277da,
    name: "mypage-promotion-start_setting"
  }, {
    path: "/mypage/user/careers",
    component: _cc9024a4,
    name: "mypage-user-careers"
  }, {
    path: "/mypage/user/portfolios",
    component: _25065cc2,
    children: [{
      path: "",
      component: _9fd26c76,
      name: "mypage-user-portfolios"
    }, {
      path: ":portfolioId",
      component: _3d3857a1,
      name: "mypage-user-portfolios-portfolioId"
    }]
  }, {
    path: "/mypage/user/prices",
    component: _3c40be3e,
    name: "mypage-user-prices"
  }, {
    path: "/mypage/user/reviews",
    component: _1d62d614,
    name: "mypage-user-reviews"
  }, {
    path: "/mypage/user/services",
    component: _93656996,
    name: "mypage-user-services"
  }, {
    path: "/customize/requests/add/:userId",
    component: _549adc3c,
    name: "customize-requests-add-userId"
  }, {
    path: "/mypage/blogs/edit/:id?",
    component: _4c9db870,
    name: "mypage-blogs-edit-id"
  }, {
    path: "/mypage/customize/requests/:id?/detail",
    component: _a6468990,
    name: "mypage-customize-requests-id-detail"
  }, {
    path: "/mypage/ordermade/requests/:id?/detail",
    component: _3f610458,
    name: "mypage-ordermade-requests-id-detail"
  }, {
    path: "/customize/requests/add/:userId?/:serviceId",
    component: _5c041ed1,
    name: "customize-requests-add-userId-serviceId"
  }, {
    path: "/mypage/promotion/receipt/:year?/:month?",
    component: _f76c5198,
    name: "mypage-promotion-receipt-year-month"
  }, {
    path: "/blogs/categories/:blogCategoryId",
    component: _741b1fcc,
    name: "blogs-categories-blogCategoryId"
  }, {
    path: "/blogs/ss/:hashId?",
    component: _ea77f044,
    name: "blogs-ss-hashId"
  }, {
    path: "/business/projects/:id",
    component: _14a71cbd,
    name: "business-projects-id"
  }, {
    path: "/campaign/participations/:campaignEventId?",
    component: _5b43356b,
    name: "campaign-participations-campaignEventId"
  }, {
    path: "/forms/delivery/:talkroomId?",
    component: _0455bf8d,
    name: "forms-delivery-talkroomId"
  }, {
    path: "/forms/estimate/:offerId?",
    component: _6bdb98e8,
    name: "forms-estimate-offerId"
  }, {
    path: "/forms/order/:talkroomId?",
    component: _656f092e,
    name: "forms-order-talkroomId"
  }, {
    path: "/mypage/analytics/:id",
    component: _37fa8944,
    name: "mypage-analytics-id"
  }, {
    path: "/mypage/blog_orders/:blogOrderId",
    component: _325219d2,
    name: "mypage-blog_orders-blogOrderId"
  }, {
    path: "/requests/categories/:categoryId?",
    component: _2c6fe70e,
    name: "requests-categories-categoryId"
  }, {
    path: "/customize/requests/:id?/detail",
    component: _26ba7f64,
    name: "customize-requests-id-detail"
  }, {
    path: "/mypage/blog_charges/:blogChargeId?/receipt",
    component: _214c2809,
    name: "mypage-blog_charges-blogChargeId-receipt"
  }, {
    path: "/ordermade/requests/:id?/detail",
    component: _7f27096e,
    name: "ordermade-requests-id-detail"
  }, {
    path: "/blogs/:id",
    component: _344e0028,
    name: "blogs-id"
  }, {
    path: "/categories/:categoryId",
    component: _0940d50f,
    name: "categories-categoryId"
  }, {
    path: "/requests/:id",
    component: _02c6ad54,
    name: "requests-id"
  }, {
    path: "/services/:id",
    component: _30bd1ff0,
    name: "services-id"
  }, {
    path: "/talkrooms/:talkroomId?",
    component: _232d4ff2,
    children: [{
      path: "",
      component: _661f7d4a,
      name: "talkrooms-talkroomId"
    }, {
      path: "information",
      component: _ce9d36b8,
      name: "talkrooms-talkroomId-information"
    }]
  }, {
    path: "/users/:id",
    component: _62924cdf,
    name: "users-id"
  }, {
    path: "/users/:id/careers",
    component: _76facbfc,
    name: "users-id-careers"
  }, {
    path: "/users/:id/portfolios",
    component: _475b4024,
    children: [{
      path: "",
      component: _eeb2881e,
      name: "users-id-portfolios"
    }, {
      path: ":portfolioId",
      component: _2ce7dbf5,
      name: "users-id-portfolios-portfolioId"
    }]
  }, {
    path: "/users/:id/prices",
    component: _6fa41a0d,
    name: "users-id-prices"
  }, {
    path: "/users/:id/reviews",
    component: _482d8268,
    name: "users-id-reviews"
  }, {
    path: "/users/:id/services",
    component: _364fad3e,
    name: "users-id-services"
  }, {
    path: "/blogs/:id/:blogId",
    component: _6f08d052,
    name: "blogs-id-blogId",
    children: [{
      path: "complete",
      component: _7bf0f6f4,
      name: "blogs-id-blogId-complete"
    }, {
      path: "confirm",
      component: _55515983,
      name: "blogs-id-blogId-confirm"
    }, {
      path: "input",
      component: _96cf7766,
      name: "blogs-id-blogId-input"
    }]
  }, {
    path: "/categories/:categoryId/:categoryTypeId",
    component: _0d600bf2,
    name: "categories-categoryId-categoryTypeId"
  }, {
    path: "/",
    component: _140b13fb,
    name: "index"
  }, {
    path: "/app/requests/add",
    component: _5fe0e4bd,
    name: "app_request_add"
  }],

  parseQuery: function(query) {
      return require('qs').parse(query);
    },
  stringifyQuery: function(query) {
      let result = require('qs').stringify(query, {
        arrayFormat: 'brackets',
        skipNulls: true });

      return result ? '?' + result : '';
    },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
